import { z } from 'zod'

import { safeNormalizeUrlToString } from '@mntn-dev/utilities'

export const UrlNormalizerSchema = z
  .string()
  .transform((val) => {
    const result = safeNormalizeUrlToString(val)

    return result.success ? result.url : val
  })
  .superRefine((val, ctx) => {
    const result = z.url().safeParse(val)

    if (!result.success) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_format,
        format: 'url',
      })
    }
  })
